// extracted by mini-css-extract-plugin
export default {"root":"SuggestedQuestionsSubForm_root__hSy2B","body":"SuggestedQuestionsSubForm_body__UwUPW"};